import { ValidationObserver, ValidationProvider } from "vee-validate";
import imageToBase64 from 'image-to-base64/browser';
import firebase from 'firebase';

export default {
    name: "SharePhotoDlg",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            dialogSharePhoto: false,
            email: '',
            photo: '',
            loading: false,
            attachments: []
        }
    },
    methods: {
        async sharePhotoByEmail() {
            this.loading = true;

            const photoBase64 = await imageToBase64(this.photo);

            this.attachments.push({
                filename: `Photo.png`,
                content: photoBase64,
                encoding: 'base64'
            });

            await firebase
                .firestore()
                .collection('email')
                .add({
                    to: this.email,
                    facilityId: this.$store.state.authModule.currentFacility,
                    message: {
                        subject: "Gallery Photo",
                        html: `Gallery Photo`,
                        attachments: this.attachments
                    }
                }).then(() => {
                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['SharePhotoDlg.SuccessSendingPhoto'],
                        type: "success"
                    });
                    this.close();
                }).catch((error) => {
                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['SharePhotoDlg.ErrorSendingPhoto'],
                        type: "error"
                    });
                    this.loading = false;
                })
        },
        open(photo) {
            this.dialogSharePhoto = true;
            this.photo = photo;
        },
        close() {
            this.dialogSharePhoto = false;
            this.photo = "";
            this.email = "";
            this.loading = false;
            this.attachments = [];
            this.$refs.observer.reset();
        }
    }
}